import { render, staticRenderFns } from "./SavingOverlay.vue?vue&type=template&id=21936779&"
import script from "./SavingOverlay.vue?vue&type=script&lang=js&"
export * from "./SavingOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports